import axios from '../axios';
import { BASE_URL, encodeQueryFilter } from '../Utils';
 
const EXCEPTIONS_URL = `${BASE_URL}/exceptions`;

export function reportException(data) {
  return axios({
    url: EXCEPTIONS_URL,
    method: 'post',
    data,
  });
}
 
export async function getTodayExceptions(filter={}) {
  return axios({
    url: `${EXCEPTIONS_URL}?filter=${encodeQueryFilter(filter)}`,
    method: "get"
  })
}